/**
 * The MessageBox view allows to create message control on a map.
 *
 * The tomtom.messageBox() method creates a new instance of MessageBox component.
 *
 * @class messageBox
 */
define('display/messageBox',["leaflet"], function (L) {
    "use strict";

    L.MessageBox = L.Class.extend({
        options: {
            closeable: true,
            closeAfter: false
        },

        initialize: function (options) {
            L.Util.setOptions(this, options);
        },

        onAdd: function (map) {
            this._map = map;
            this._container = this.container = L.DomUtil.create("div", "leaflet-messageBox");
            this.contentContainer = L.DomUtil.create("div", "leaflet-messageBox-content", this.container);
            if (this.options.closeable) {
                this.closeButton = L.DomUtil.create("div", "leaflet-messageBox-close-button", this.container);
                this.closeButton.innerHTML = "&#215;";
                L.DomEvent.on(this.closeButton, "click", this.onRemove, this);
            }
            var that = this;
            if (this.options.closeAfter && parseInt(this.options.closeAfter, 10) === this.options.closeAfter) {
                setTimeout(function () {
                    that.close();
                }, this.options.closeAfter);
            }
            L.DomEvent.disableClickPropagation(this.container);
            L.DomEvent.disableScrollPropagation(this.container);

            if (this.options.content) {
                this.setContent(this.options.content);
            }

            map._container.appendChild(this.container);
            return this.container;
        },
        addTo: function (map) {
            map.addLayer(this);
            return this;
        },
        onRemove: function () {
            this._map._container.removeChild(this.container);
            return this;
        },
        /**
         * Method used to get set the HTML content of the message box.
         *
         * @chainable
         * @method setContent
         * @param {String|HTMLElement} content The text or HTML element to be a content of the message box.
         * @return {MessageBox} Returns itself allowing chaining.
         */
        setContent: function (content) {
            if (!this.contentContainer) {
                this.options.content = content;
                return this;
            }
            if (content === undefined || content === null || typeof content === "string") {
                this.contentContainer.innerHTML = content || "";
                return this;
            }
            while (this.contentContainer.firstChild) {
                this.contentContainer.lastChild.remove();
            }
            this.contentContainer.appendChild(content);
            return this;
        },
        close: function () {
            return this.onRemove();
        },
        openOn: function (map) {
            return this.addTo(map);
        }
    });

    L.messageBox = function (options) {
        return new L.MessageBox(options);
    };

    /**
     * The method to instantiates the messageBox control.
     *
     * @method messageBox
     * @param {Object} [options] Options to be passed to the messageBox control.
     * @param {Boolean} [options.closeable=true] Should the messageBox contain the close button.
     * @param {Integer} [options.closeAfter=0] Number of milliseconds after which the control will be automatically
     *     closed. If value is 0 it will not be closed automatically, which is the default behaviour.
     *
     * @example
     * ```javascript
     *
     * messageBox({content='Hello world', closeAfter: 1000}).addTo(map);
     * ```
     */
    return L.messageBox;
});
